import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY, Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { SoldToActions } from '../../../../features/sold-to-base/store/actions';
import { UserIdService } from '../../../auth';
import { LoginLogoutActionTypes } from '../../../auth/user-auth/store/actions/login-logout.action';
import { normalizeHttpError } from '../../../util';
import { AnalyticsMetadataConnector } from '../../connectors/analytics-metadata-connector';
import { UserActions } from '../actions';
import { AnalyticsMetadataActions } from '../actions/analytics-metadata.action';
import { UserModuleLoadedActions } from '../actions/user.actions';

@Injectable()
export class AnalyticsMetadataEffects {
  loadAnalyticsMetadata$: Observable<AnalyticsMetadataActions> = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.AnalyticsMetadataActionTypes.LoadAnalyticsMetadata),
      map((action: UserActions.LoadAnalyticsMetadata) => action.payload),
      switchMap((payload) =>
        this.connector.load(payload).pipe(
          map((data) => new UserActions.LoadAnalyticsMetadataSuccess(data)),
          catchError((error) => of(new UserActions.LoadAnalyticsMetadataFail(normalizeHttpError(error))))
        )
      )
    )
  );

  loadAnalyticsMetadataAfterContextChange$: Observable<AnalyticsMetadataActions> = createEffect(() =>
    this.actions$.pipe(
      ofType(
        SoldToActions.ChangeSoldToActionTypes.ChangeSoldToSuccess,
        UserModuleLoadedActions.USER_MODULE_LOADED,
        LoginLogoutActionTypes.Login,
        LoginLogoutActionTypes.Logout
      ),
      switchMap(() =>
        this.userIdService.takeUserId().pipe(
          map((userId) => new UserActions.LoadAnalyticsMetadata(userId)),
          catchError(() => EMPTY)
        )
      )
    )
  );

  constructor(private actions$: Actions, private connector: AnalyticsMetadataConnector, private userIdService: UserIdService) {}
}
